/** @jsxImportSource @emotion/react */

import { useTranslation } from "react-i18next";

import { TitleTableStyle } from "./index.style";

interface Props {
  listTitle: string[];
}

export const TitleTable: React.FC<Props> = ({ listTitle }) => {
  const { t } = useTranslation("transaction");

  return (
    <div css={TitleTableStyle.titleHeader}>
      {listTitle.map((itemMap, index) => {
        return (
          <div css={TitleTableStyle.itemHeader} key={`key-${index}-titleTable`}>
            <span>{t(itemMap)}</span>
          </div>
        );
      })}
    </div>
  );
};
